import {extendsAPIServices} from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import {DELETE, GET, POST, PATCH} from "../../constants/HTTPConstants";

const baseAdminAPI = getEnv('baseAdminAPI');
const api = extendsAPIServices(baseAdminAPI);

export const _createNewEvent = (args) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/events`,
        data: args
    });
};

export const _updateEvent = (args, eventId)=>{
    return api.makeAuthRequest({
        method: PATCH,
        url: `/events/${eventId}`,
        data: args
    })
};

export const _updateStatusEvent = (eventId, status) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/events/${eventId}/status`,
        data: {
            status
        }
    });
};

export const _deleteEvent = (eventId) => {
    return api.makeAuthRequest({
        method: DELETE,
        url: `/events/${eventId}`,
    });
};

export const _getListEvents = ({page = 1, limit = 10}) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/events`,
        params: {
            page,
            limit
        }
    });
};




// WEBPACK FOOTER //
// ./src/services/apis/EventServices.js